import React, { useState, useContext, useEffect } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';
import TermsContent from './TermsContent.component';

const { Modal, ModalContext, ModalButtonActionType } = ModalModule;
const { Communication, Util } = Utils;

export const TermsDialog = ({ modalId, data: { termType = 'General', showAccept, callback } }) => {
	const [termContent, setTermContent] = useState(null);
	const [termVersion, setTermVersion] = useState(0);
	const { showError, closeModal } = useContext(ModalContext);

	const getTerms = async () => {
		const response = await Communication.getTerms(termType);

		if (Communication.isSuccessful(response)) {
			setTermContent(response.data.Content);
			setTermVersion(response.data.TermsVersion);
		} else {
			showError({ response });
		}
	};

	useEffect(() => {
		getTerms();
	}, []);

	const closeTermsModal = async () => {
		if (showAccept) {
			const currentDate = Util.getCurrentDate();
			const params = {
				TermType: termType,
				ViewedDate: currentDate,
				AcceptedDate: currentDate,
				ViewedVersion: termVersion,
				AcceptedVersion: termVersion,
			};

			const response = await Communication.acceptTerms(params);

			if (!Communication.isSuccessful(response)) {
				return showError({ response });
			}
		}

		// notify caller that the terms have been accepted
		if (callback) {
			callback(true);
		}

		closeModal(modalId, ModalButtonActionType.Ok);
	};

	const termsModalButton = {
		type: ModalButtonActionType.Ok,
		text: `${showAccept ? 'Accept' : 'OK'}`,
		onClick: closeTermsModal,
		dataqa: 'terms-accept-button',
	};

	return (
		<Modal
			modalId={modalId}
			header="Terms"
			className="common-terms terms-dialog"
			primaryButton={termsModalButton}
		>
			<div className="body">
				<TermsContent termsContent={termContent} />
			</div>
		</Modal>
	);
};
